
import { createSlice } from "@reduxjs/toolkit";


const certificationInitialState = {
    // reportinigPeriodCovered : {
    //     from : "",
    //     to : ""
    // },
    // organizationBoundaries : {
    //     from : "",
    //     to : ""
    // },
    // leadVerifierName : null,
    // reportingBoundaries : {
    //     from : "",
    //     to : ""
    // },
    listOfCertifications : [],
    selectedCertification : null,
};

const certificationSlice = createSlice({
    name : 'certification',
    initialState : certificationInitialState,
    reducers : {
        setCertificationDetails : function(state, action){

            state.listOfCertifications = [...state.listOfCertifications, action.payload]
            // state.reportinigPeriodCovered = action.payload.reportinigPeriodCovered;
            // state.organizationBoundaries = action.payload.organizationBoundaries;
            // state.leadVerifierName = action.payload.leadVerifierName;
            // state.reportingBoundaries = action.payload.reportingBoundaries;
        },
        clearCertificationDetails : function(state){
            state.reportinigPeriodCovered = null;
            state.organizationBoundaries = null;
            state.leadVerifierName = null;
            state.reportingBoundaries = null;
        },
        setSelectedCertifications : function(state, action){
            state.selectedCertification = action.payload;
        }
    }
});


export const {clearCertificationDetails, setCertificationDetails ,setSelectedCertifications} = certificationSlice.actions;
export default certificationSlice.reducer;